var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.52127 22.8803C1.47373 22.8803 1.42303 22.8742 1.3755 22.865C1.06813 22.7973 0.849488 22.5329 0.849488 22.2286V21.2294C0.84632 12.2493 8.3753 4.94462 17.6281 4.94462H20.6923V1.53517C20.6923 1.28 20.8444 1.04942 21.082 0.941822C21.3197 0.83422 21.6017 0.871112 21.8013 1.03405L31.6055 9.04272C31.7576 9.16569 31.8463 9.35015 31.8463 9.54383C31.8463 9.73752 31.7576 9.9189 31.6055 10.045L21.8013 18.0536C21.6017 18.2166 21.3197 18.2534 21.082 18.1458C20.8444 18.0382 20.6923 17.8077 20.6923 17.5525V14.1553C6.14449 14.6104 2.16769 22.4284 2.12967 22.5083C2.01559 22.742 1.77477 22.8834 1.5181 22.8834L1.52127 22.8803ZM17.6281 6.25121C9.53823 6.25121 2.88066 12.3261 2.24374 20.0212C4.48723 17.3896 9.93116 13.0025 21.3577 12.8303C21.5352 12.8303 21.7126 12.8949 21.8394 13.0178C21.9693 13.1408 22.039 13.3099 22.039 13.4851V16.1475L30.1225 9.54383L22.0422 2.94015V5.59638C22.0422 5.95608 21.7411 6.25121 21.3672 6.25121H17.6281Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 22,
    fill: "currentColor",
    transform: "translate(0.846313 0.880371)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.91a5f970.svg";
export { ForwardRef as ReactComponent };